import React from 'react';
import StudyManagementComponent from '../../../components/admin/community/StudyManagementComponent';

const StudyManagement: React.FC = () => {
  return <StudyManagementComponent />;
};

export default StudyManagement;
